import React from "react";
import "./footer.css";
import BidTypeLogo from "../../assets/TTGLogoWhite.png";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="left-section">
          <a href="/">
            <div>
              <img src={BidTypeLogo} alt="Logo" className="logo-left-footer" />
            </div>
          </a>
        </div>
        <div className="right-section">
          <p id="rightone-text">
           Tak Till Golv
            <br />
            <p id="rightone-text2">Group Of Snáithe AB</p>
            <br />
            VAT-ID number: SE559439810801
            <br />
            Organization ID number: 559439-8108
            <br /> <br />
            Stockholm Office:
            <br />
            Skyttbrinksvägen 42
            <br />
            147 39 Tumba
            <br />
            Sweden
          </p>
          <p />
          <p id="right-text">
          Headquarters: <br />
            Sadelgatan 2
            <br />
            213 77 Malmö
            <br />
            Sweden
            <br />
            <br />
            Email:{" "}
            <a id="emailid" href="mailto:taktillgolv@snaithe.com">
              taktillgolv@snaithe.com
            </a>
            <br />
            Website:{" "}
            <a id="emailid" href="https://taktillgolv.se/">
            taktillgolv.se
            </a>
            <br />
            Phone:{" "}
            <a id="emailid" href="tel:+46793335151">
              +46 79 333 51 51
            </a>
            <br />
            Phone:{" "}
            <a id="emailid" href="tel:+46790161617">
              +46 790 161 617
            </a>
            <br />
            Phone:{" "}
            <a id="emailid" href="tel:+46720211211">
              +46 720 211 211
            </a>
            <br />
          </p>
        </div>
        <div className="center-section">
          <div className="icons-tooltip">
            <a href="https://www.facebook.com/" className="icon-link">
              <div className="icon-socials">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <g clip-path="url(#clip0_56_103)">
                    <path
                      d="M20.818 10.1708C20.818 4.55366 16.2644 0 10.6472 0C5.0301 0 0.47644 4.55358 0.47644 10.1708C0.47644 15.2473 4.19577 19.4551 9.05805 20.218V13.1108H6.47562V10.1708H9.05805V7.93004C9.05805 5.38099 10.5765 3.97297 12.8997 3.97297C14.0125 3.97297 15.1764 4.17162 15.1764 4.17162V6.67459H13.8939C12.6304 6.67459 12.2364 7.45861 12.2364 8.26298V10.1708H15.0572L14.6063 13.1108H12.2364V20.218C17.0987 19.4551 20.818 15.2474 20.818 10.1708Z"
                      fill="#CBCBCB"
                    />
                    <path
                      d="M14.6063 13.1105L15.0572 10.1705H12.2364V8.26267C12.2364 7.45822 12.6304 6.67427 13.8939 6.67427H15.1764V4.1713C15.1764 4.1713 14.0125 3.97266 12.8996 3.97266C10.5765 3.97266 9.05802 5.38068 9.05802 7.92973V10.1705H6.47559V13.1105H9.05802V20.2177C9.58373 20.3001 10.1151 20.3414 10.6472 20.3413C11.1793 20.3414 11.7107 20.3001 12.2364 20.2177V13.1105H14.6063Z"
                      fill="#00171f"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_56_103">
                      <rect
                        width="20.3416"
                        height="20.3416"
                        fill="white"
                        transform="translate(0.47644)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className="icon-name">Facebook</p>
              </div>
            </a>
          </div>
          <div className="icons-tooltip">
            <a
              href="https://www.instagram.com/SnaitheAB/"
              className="icon-link"
            >
              <div id="icon-ig">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="21"
                  viewBox="0 0 22 21"
                  fill="none"
                >
                  <g clip-path="url(#clip0_56_106)">
                    <path
                      d="M16.2913 0H5.06922C2.33489 0 0.118286 2.13451 0.118286 4.76756V15.574C0.118286 18.2071 2.33489 20.3416 5.06922 20.3416H16.2913C19.0256 20.3416 21.2423 18.2071 21.2423 15.574V4.76756C21.2423 2.13451 19.0256 0 16.2913 0Z"
                      fill="url(#paint0_radial_56_106)"
                    />
                    <path
                      d="M16.2913 0H5.06922C2.33489 0 0.118286 2.13451 0.118286 4.76756V15.574C0.118286 18.2071 2.33489 20.3416 5.06922 20.3416H16.2913C19.0256 20.3416 21.2423 18.2071 21.2423 15.574V4.76756C21.2423 2.13451 19.0256 0 16.2913 0Z"
                      fill="#91E5F6"
                    />
                    <path
                      d="M10.681 2.22461C8.44005 2.22461 8.15875 2.23407 7.27864 2.2726C6.40018 2.31138 5.80054 2.44527 5.27591 2.64177C4.73312 2.84471 4.27277 3.11622 3.81415 3.55802C3.35511 3.99973 3.07316 4.44304 2.86175 4.96548C2.65711 5.47084 2.51791 6.04851 2.47839 6.89404C2.43903 7.74163 2.42871 8.01259 2.42871 10.1706C2.42871 12.3287 2.43861 12.5987 2.47855 13.4462C2.51898 14.2921 2.65802 14.8695 2.86192 15.3747C3.07283 15.8974 3.35478 16.3407 3.81357 16.7824C4.27211 17.2244 4.73246 17.4965 5.27484 17.6995C5.79988 17.896 6.3996 18.0299 7.2779 18.0686C8.15809 18.1072 8.43914 18.1166 10.68 18.1166C12.9212 18.1166 13.2016 18.1072 14.0817 18.0686C14.9602 18.0299 15.5605 17.896 16.0855 17.6995C16.6281 17.4965 17.0878 17.2244 17.5462 16.7824C18.0052 16.3407 18.2871 15.8974 18.4986 15.375C18.7014 14.8695 18.8407 14.2919 18.882 13.4463C18.9215 12.5988 18.9318 12.3287 18.9318 10.1706C18.9318 8.01259 18.9215 7.74179 18.882 6.8942C18.8407 6.04827 18.7014 5.47092 18.4986 4.96572C18.2871 4.44304 18.0052 3.99973 17.5462 3.55802C17.0873 3.11606 16.6282 2.84455 16.085 2.64185C15.559 2.44527 14.959 2.3113 14.0806 2.2726C13.2004 2.23407 12.9201 2.22461 10.6784 2.22461H10.681ZM9.94076 3.65655C10.1605 3.65623 10.4056 3.65655 10.681 3.65655C12.8843 3.65655 13.1453 3.66417 14.0154 3.70224C14.8199 3.73767 15.2566 3.86711 15.5474 3.97589C15.9325 4.11987 16.2071 4.29206 16.4957 4.57025C16.7845 4.84836 16.9632 5.1132 17.1132 5.48403C17.2261 5.76373 17.3607 6.18423 17.3974 6.95896C17.4369 7.79662 17.4455 8.04819 17.4455 10.1688C17.4455 12.2894 17.4369 12.5411 17.3974 13.3786C17.3606 14.1534 17.2261 14.5739 17.1132 14.8536C16.9637 15.2245 16.7845 15.4885 16.4957 15.7665C16.2069 16.0446 15.9327 16.2167 15.5474 16.3607C15.2569 16.47 14.8199 16.5991 14.0154 16.6346C13.1455 16.6726 12.8843 16.6809 10.681 16.6809C8.47767 16.6809 8.21651 16.6726 7.34672 16.6346C6.54219 16.5988 6.10552 16.4694 5.8144 16.3606C5.42939 16.2165 5.15428 16.0444 4.86548 15.7663C4.57667 15.4882 4.39794 15.224 4.24801 14.853C4.13505 14.5732 4.00047 14.1527 3.96383 13.378C3.9243 12.5403 3.91638 12.2888 3.91638 10.1668C3.91638 8.04493 3.9243 7.79463 3.96383 6.95697C4.00063 6.18224 4.13505 5.76174 4.24801 5.48165C4.39761 5.11081 4.57667 4.84597 4.86556 4.56787C5.15436 4.28976 5.42939 4.11757 5.81449 3.97327C6.10535 3.86402 6.54219 3.73489 7.34672 3.6993C8.10792 3.66616 8.40292 3.65623 9.94076 3.65456V3.65655ZM15.0857 4.97589C14.539 4.97589 14.0955 5.40259 14.0955 5.92908C14.0955 6.4555 14.539 6.8826 15.0857 6.8826C15.6323 6.8826 16.0759 6.4555 16.0759 5.92908C16.0759 5.40267 15.6323 4.97557 15.0857 4.97557V4.97589ZM10.681 6.08999C8.34086 6.08999 6.4435 7.91708 6.4435 10.1706C6.4435 12.4242 8.34086 14.2504 10.681 14.2504C13.0212 14.2504 14.9179 12.4242 14.9179 10.1706C14.9179 7.91716 13.0211 6.08999 10.6808 6.08999H10.681ZM10.681 7.52193C12.2 7.52193 13.4316 8.7077 13.4316 10.1706C13.4316 11.6334 12.2 12.8193 10.681 12.8193C9.16189 12.8193 7.93051 11.6334 7.93051 10.1706C7.93051 8.7077 9.16189 7.52193 10.681 7.52193Z"
                      fill="#00171f"
                    />
                  </g>
                  <defs>
                    <radialGradient
                      id="paint0_radial_56_106"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.72934 21.9083) rotate(-90) scale(20.16 19.4716)"
                    >
                      <stop stop-color="#FFDD55" />
                      <stop offset="0.1" stop-color="#FFDD55" />
                      <stop offset="0.5" stop-color="#FF543E" />
                      <stop offset="1" stop-color="#C837AB" />
                    </radialGradient>
                    <clipPath id="clip0_56_106">
                      <rect
                        width="21.124"
                        height="20.3416"
                        fill="white"
                        transform="translate(0.118286)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <p className="icon-name">Instagram</p>
              </div>
            </a>
          </div>
          <a href="https://twitter.com/SnaitheAB" className="icon-link">
            <div className="icon-socials">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="22"
                viewBox="0 0 28 22"
                fill="none"
              >
                <path
                  d="M3.55145 0L12.2954 11.9305L3.49634 21.6306H5.47674L13.1804 13.1379L19.4047 21.6306H26.1439L16.908 9.02882L25.0981 0H23.1177L16.0232 7.82142L10.2909 0H3.55145ZM6.46392 1.48858H9.55984L23.2312 20.1417H20.1352L6.46392 1.48858Z"
                  fill="#91E5F6"
                />
              </svg>
              <p className="icon-name">Twitter</p>
            </div>
          </a>
          <a href="https://www.youtube.com/@SnaitheAB" className="icon-link">
            <div className="icon-socials">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31"
                height="21"
                viewBox="0 0 31 21"
                fill="none"
              >
                <g clip-path="url(#clip0_56_113)">
                  <path
                    d="M29.952 3.17272C29.7814 2.55949 29.4488 2.00042 28.9872 1.55119C28.5256 1.10196 27.951 0.778248 27.3209 0.612282C25.0138 0 15.7285 0 15.7285 0C15.7285 0 6.44272 0.0185334 4.13563 0.630816C3.50543 0.796792 2.93091 1.12052 2.46929 1.56977C2.00766 2.01902 1.67503 2.57811 1.50452 3.19137C0.806676 7.18036 0.53597 13.2587 1.52368 17.0881C1.69421 17.7013 2.02685 18.2604 2.48847 18.7096C2.9501 19.1588 3.52461 19.4825 4.15479 19.6485C6.46188 20.2608 15.7474 20.2608 15.7474 20.2608C15.7474 20.2608 25.0328 20.2608 27.3398 19.6485C27.97 19.4826 28.5445 19.1589 29.0062 18.7096C29.4678 18.2604 29.8005 17.7013 29.971 17.0881C30.7071 13.0934 30.9339 7.01887 29.952 3.17272Z"
                    fill="#91E5F6"
                  />
                  <path
                    d="M12.7731 14.4722L20.4759 10.1306L12.7731 5.78906V14.4722Z"
                    fill="#00171f"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_56_113">
                    <rect
                      width="29.73"
                      height="20.3416"
                      fill="white"
                      transform="translate(0.87854)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <p className="icon-name">YouTube</p>
            </div>
          </a>
        </div>
        <p className="bottom-text">© 2023 Snáithe AB - All Rights Reserved</p>{" "}
        <div class="line1"></div>
      </footer>
    );
  }
}

export default Footer;
